var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.slides.length)?_c('div',{staticClass:"flickity-container"},[_c('flickity',{ref:"flickity",class:['flickity'],attrs:{"options":_vm.flickityOptions},on:{"init":_vm.flickityInit}},_vm._l((_vm.slides),function(slide,i){return _c('vue-link',{key:slide.url + i,class:[
        'image-container',
        {
          active: _vm.active === i,
          'noisy-image-invert': _vm.loaded.indexOf(i) >= 0,
        } ],attrs:{"to":slide.active ? slide.url : false,"tabindex":"-1"}},[_c('div',{staticClass:"image",attrs:{"data-flickity-bg-lazyload":slide.homeimage.medium,"alt":slide.title}})])}),1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }